export default __webpack_public_path__ + "static/media/shield-done-round.4a0924bf.svg";